import { HTTP, HTTP_FILE, authHeader } from './http-service';

class CaseManagementService {
  getByMeasures(umrs) {
    return HTTP.post(
      '/CaseManagement/by-measures',
      { umrs },
      {
        headers: authHeader(),
      },
    ).then((response) => {
      return response.data;
    });
  }

  getByAddress(addressLine1, postcode) {
    return HTTP.post(
      '/CaseManagement/by-address',
      { addressLine1, postcode },
      {
        headers: authHeader(),
      },
    ).then((response) => {
      return response.data;
    });
  }

  getComplaint(complaintNumber) {
    return HTTP.get(`/CaseManagement/complaint/${complaintNumber}`, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }

  getDocumentDownloadUrl(retrofitProjectId, document) {
    if (document.documentId) {
      const lodgementPath = document.lodgementId
        ? `/${encodeURIComponent(document.lodgementId)}`
        : '';
      return HTTP_FILE.get(
        `/File/Download/${encodeURIComponent(retrofitProjectId)}/${encodeURIComponent(document.documentId)}${lodgementPath}`,
        { headers: authHeader() },
      ).then((response) => response.data);
    }

    return HTTP_FILE.post(
      '/File/GetPresignedUrl',
      {
        projectOrAssessmentId: retrofitProjectId,
        link: document.link,
      },
      { headers: authHeader() },
    ).then((response) => response.data);
  }
}

export default new CaseManagementService();
